import { ReactElement } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import { getAuthState } from '../../redux/selectors'

// eslint-disable-next-line
export function PrivateRoute({ component: Component, ...rest }: any): ReactElement {
  const { token } = useSelector(getAuthState)
  return (
    <Route
      {...rest}
      render={(props) => (token ? <Component {...props} /> : <Redirect to={{ pathname: '/login' }} />)}
    />
  )
}
